import { IFileDescriptor } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/metadata/file-descriptor';
import { ACL } from '@wix/media-platform-js-client/dist/mjs/src/types/media-platform/media-platform';

import {
  SecurityGroups,
  WebHook,
} from '../containers/applications/applications.types';

export { ACL };

export interface Organization {
  id: string;
  name: string;
  ownerId: string;
  dateCreated: string;
  dateUpdated: string;
}

export type Invitation = any;

export interface InvitationWithOrganization {
  invitation: Invitation;
  organization: Organization;
}

export interface ProjectService {
  host: string;
  instanceType?: any;
  maximumInstanceNumber?: number;
  minimumInstanceNumber?: number;
  name?: string;
  reserved?: boolean;
  status?: string;
  type?: string;
  ipAddress?: string; // TODO: talk to BE guys and try to remove this
}

export enum ProjectStatus {
  READY = 'ready',
  FAILED = 'failed',
  DELETING = 'deleting',
  PENDING = 'pending',
}

// TODO: improve ImageService, VideoPackagerService, AudioService
export interface Project {
  id: string;
  name: string;
  domain: string;
  filesHost: string;
  services: ProjectService[];
  dateCreated: string;
  dateUpdated: string;
  status: ProjectStatus;
  apiHost: string;
  organizationId: string;
}

export interface SharedSecret {
  activationDate: string;
  deactivationDate: string | null;
  secret: string;
}

export interface Application {
  id: string;
  name: string;
  dateCreated: string;
  dateUpdated: string;
  securityGroups: SecurityGroups;
  webhooks: WebHook[];
  sharedSecrets: SharedSecret[];
}

export type ApplicationWithProject = {
  project: Project;
} & Application;

export interface DropdownOption {
  disabled?: boolean;
  id: string;
  value: string;
}

export interface Source {
  path?: string;
  fileId?: string;
}

export interface Destination {
  directory: string;
  acl: ACL;
}

/**
 * Data type that comes from server and represents an item in file system.
 * Can be any file (image, video, etc) or a folder (use mimeType to determinate it)
 */
export interface FileDescriptor extends IFileDescriptor {
  id: string;
}

export enum MimeTypeBase {
  Application = 'application',
  Audio = 'audio',
  Example = 'example',
  Image = 'image',
  Message = 'message',
  Model = 'model',
  multipart = 'multipart',
  Text = 'text',
  Video = 'video',
}

export enum MimeTypeSuffix {
  Pdf = 'pdf',
  Zip = 'zip',
}

export enum ImagesMetadataMimeTypeSuffixes {
  JPEG = 'jpeg',
  PNG = 'png',
  HEIC = 'heic',
  AVIF = 'avif',
  GIF = 'gif',
  WEBP = 'webp',
  JPG = 'jpg',
}

export interface MPCMimeType {
  type: MimeTypeBase | undefined | null;
  suffix: MimeTypeSuffix | string | undefined;
}

export interface ProjectInOrganizationId {
  project: Project;
  organizationId: string;
}

export interface CreatedEntity {
  createdBy: string;
  createdByName: string;
  dateUpdated: string;
  dateCreated: string;
}

export interface CreatedEntityWithId extends CreatedEntity {
  id: string;
}
